export default __webpack_public_path__ + "static/media/illustration.6fb25cf2.png";